module.exports = __webpack_public_path__ + "img/video3.4db7c697.png";